import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../components/Button'
import Icon from '../components/Icon'
import styles from './Login.module.css'
import { login } from '../api/security'
  
export default function Login() {
  const navigate                        = useNavigate()
  const [username, setUsername]         = useState('')
  const [password, setPassword]         = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError]               = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    try {
      const result = await login(username, password)
      if (result?.mfaRequired) {
        navigate('/mfa', { state: result })
        return
      }
      navigate('/dashboard')   // react-router
    } catch (err) {
      if (err.status === 403 && err.resetkey) {
        // Forced password change (temp/expired password) — send them to the
        // reset form instead of dead-ending on the error message.
        navigate('/resetpw/' + err.resetkey)
        return
      }
      setError(err.message)
    }
  }

  return (
    <div className={styles.pageBackground}>
      <div className={styles.card}>

        {/* Logo */}
        <div className={styles.logoRow}>
          <img src="/GaussIQlogo.png" alt="GaussIQ Logo" className={styles.logoImage} />
          <div className={styles.logoText}>
            <span className={styles.logoName}>GaussIQ</span>
            <span className={styles.logoTagline}>
              Know your customer<br />Grow your future.
            </span>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className={styles.form}>

          {error && <p className={styles.errorMessage}>{error}</p>}

          <div className={styles.fieldGroup}>
            <label htmlFor="username" className={styles.label}>Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              className={styles.input}
              autoComplete="username"
              required
            />
          </div>

          <div className={styles.fieldGroup}>
            <label htmlFor="password" className={styles.label}>Password</label>
            <div className={styles.passwordWrapper}>
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className={styles.input}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className={styles.eyeButton}
                onClick={() => setShowPassword(prev => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <Icon name={showPassword ? 'eye-off' : 'eye'} width="18" height="18" />
              </button>
            </div>
          </div>

          <div className={styles.buttonRow}>
            <Button type="submit" variant="primary" fullWidth>
              Login
            </Button>
          </div>

          <div className={styles.links}>
            <button type="button" className={styles.linkButton} onClick={() => navigate('/resetcode')}>Forgot password?</button>
          </div>

        </form>
      </div>
    </div>
  )
}